<template>
    <div>
        <modal class="new-modal-small" :name="modal_name" transition="nice-modal-fade" :delay="100" height="auto"
            width="500" :min-width="200" :max-width="500" :pivot-y="0.5" :adaptive="true" :scrollable="false" style="pointer-events:inherit !important" 
            v-bind:click-to-close="false">
            <!--Delete Confirmation Popup-->
            <div class="v-modal-content d-flex flex-column justify-content-center align-items-center text-center"
                style="background-color: #dfe8f4 !important; height: 30em !important;">
                <img src="/static/images/delete_pop_icon.svg" style="height: 10rem !important" />
                <div class="mt-5">
                    <div class="mb-4" style="color:#f30d0d;font-size: 18px;">Delete Product</div>
                    <div>
                        <span>Are you sure you want to delete the Selected Product(s)?</span>
                    </div>
                </div>
                <div v-if="disableButtonAndDisplayLoader == false" class="d-flex align-items-center justify-content-center mt-6">
                    <button type="button" class="btn new-no-button" @click="hideDeleteProductModal()">No</button>
                    <button type="button" class="btn new-yes-button ml-4" @click="deleteProductData()">Yes</button>
                </div>
                <div v-else class="d-flex align-items-center justify-content-center mt-6">
                    <button type="button" class="btn new-no-button" disabled style="border: 1px solid transparent !important;">No</button>
                    <button type="button" class="btn new-yes-button ml-4" disabled style="border: 1px solid transparent !important;position: relative;">Yes
                        <hollow-dots-spinner style="position: absolute;margin: 0;top: 22px;display: flex;justify-content: center;width: 100% !important;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                    </button>
                </div>
            </div>
        </modal>
        <sweet-modal ref="warning_modal" icon="warning">{{warning_msg}}</sweet-modal>
    </div>
</template>
<script>
    import products from '../mixins/products';
    import { HalfCircleSpinner } from "epic-spinners";
    import { SweetModal } from 'sweet-modal-vue';
    import { HollowDotsSpinner } from "epic-spinners";
    export default ({
        props: ["modal_name",'product_ids'],
        mixins:[products],
        data() {
            return {
                disableButtonAndDisplayLoader: false,
                success_msg: '',
                warning_msg: '',
            }
        },
        methods: {
            //Hide the Delete Popup
            hideDeleteProductModal() {
                this.$emit("hide-delete-product-modal")
            },
            //API Call of Delete Product
            async deleteProductData() {
                try{
                    this.disableButtonAndDisplayLoader = true;
                    let params = {
                        id: this.product_ids
                    }
                    let response = await this.deleteProducts(params)
                    this.$emit("deleteProduct")
                    setTimeout(() => {
                        this.disableButtonAndDisplayLoader = false;
                        this.$modal.hide(this.modal_name)
                    }, 1500);
                } catch(error){
                    this.warning_msg = error
                    this.$refs.warning_modal.open();
                    setTimeout(() => {
                        this.disableButtonAndDisplayLoader = false;
                        this.$refs.warning_modal.close();
                    }, 3000);
                }
            },
        },
        components: {
            products,
            HalfCircleSpinner,
            SweetModal,
            HollowDotsSpinner,
        }
    })
</script>

<style scoped>
    .btn-primary-outline {
        color: #00448b;
        border-radius: 5px;
        padding-left: 35px;
        padding-right: 35px;
        text-transform: none;
        font-weight: 500;
        line-height: 30px;
        box-shadow: none;
        border-color: 2px solid #00448b;
        box-shadow: none !important;
        font-weight: 500;
    }
</style>


// WEBPACK FOOTER //
// src/components/products/DeleteProduct.vue